<div class="backtest-detail-container padding backtest-card">
    <div class="mat-display-1 font-bold flex-centered-container-vr padding-left text-primary-contrast">
        {{isEditing ? 'Edit': 'Create New'}} Strategy
    </div>


    <mat-card class="ut-pro-elevated-card form-card margin-auto full-width">
        <div class="loader-container absolute-spinner" *ngIf="loading">
            <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
        </div>

        <!-- <div class="strategy-form-title flex-centered-container-vr pad-8">
    CREATE NEW ALGO
    <span class="spacer"></span>

    <div class="right-container display-flex">
      <div class="select-container flex-centered-container margin-8-hr">
        <div class="label">Build Mode</div>

        <mat-form-field appearance="outline" class="condensed-select-field margin-8-hr accent-outline small"
          color="accent">
          <mat-select [formControl]="strategyModeControl" (selectionChange)="onStrategyModeChange($event)">
            <mat-option *ngFor="let mode of StrategyFormBuildModeTemp | unsortedKeyValue" [value]="mode.value">
              {{ mode.value }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="select-container flex-centered-container margin-8-hr" *ngIf="EXECUTION_STYLE">
        <div class="label">Execution Mode</div>

        <mat-form-field appearance="outline" class="condensed-select-field margin-8-hr accent-outline small"
          color="accent">
          <mat-select [formControl]="executionStyleControl">
            <mat-option *ngFor="let mode of EXECUTION_STYLE | unsortedKeyValue" [value]="mode.value">
              {{ mode.value }}
            </mat-option>
          </mat-select>

          <mat-error *ngIf="executionStyleControl.hasError('required')">
            Execution style is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div> -->

        <!-- TextBuilder Mode not planned at-least for this phase  -->
        <!-- <div [ngClass]="strategyModeControl.value !== StrategyFormBuildMode.TEXT_BUILDER ? 'display-none' : 'display-block'"
      class="form-wrapper">
      <app-text-builder-mode [executionStyle]="executionStyleControl.value"></app-text-builder-mode>
    </div> -->

        <mat-tab-group color="accent" (selectedTabChange)="onStrategyModeChange($event)"
            [(selectedIndex)]="selectedIndex">
            <mat-tab [label]="mode.value" *ngFor="let mode of StrategyFormBuildModeTemp | unsortedKeyValue">
            </mat-tab>
        </mat-tab-group>

        <div class="strategy-form-wrapper padding" [class.blur-bg]="loading">

            <div class="form-wrapper timeline"
                [ngClass]="strategyModeControl.value === StrategyFormBuildMode.TEXT_BUILDER ? 'display-none' : 'display-flex-column'">
                <div class="timeline-section full-width display-flex">
                    <div class="timeline-content spacer">
                        <div class="timeline-title font-bold padding-top">
                            ORDER INSTRUMENTS
                        </div>
                        <app-strategy-setup #strategySetup></app-strategy-setup>
                    </div>
                </div>

                <div class="timeline-section full-width display-flex">
                    <div class="timeline-content">
                        <div class="timeline-title font-bold padding-top">
                            ALGO PARAMETERS
                        </div>
                        <app-strategy-define #strategyDefine [strategyMode$]="strategyMode$" [setUpRef]="strategySetup">
                        </app-strategy-define>
                    </div>
                </div>

                <div class="timeline-section full-width display-flex">
                    <div class="timeline-content">
                        <div class="timeline-title font-bold padding-top padding-bottom margin-8-bottom">
                            TAKE ENTRY
                        </div>
                        <app-strategy-take-entry #entryForm [strategyMode$]="strategyMode$"></app-strategy-take-entry>
                    </div>
                </div>

                <!-- <div class="timeline-section full-width display-flex" *ngIf="strategyMode$ | async">
              <div class="timeline-bar display-flex-column" [class.valid]="strategyExit.isValid"></div>
              <div class="timeline-content">
                  <div class="timeline-title font-bold margin-8-bottom">
                      Repair Condition
                  </div>
                  <app-repair-condition #repairCondition [strategyMode$]="strategyMode$"></app-repair-condition>
              </div>
          </div> -->

                <div class="timeline-section full-width display-flex">
                    <div class="timeline-content">
                        <div class="timeline-title font-bold padding-top">
                            TAKE EXIT
                        </div>
                        <app-strategy-take-exit #strategyExit [strategyMode$]="strategyMode$"></app-strategy-take-exit>
                    </div>
                </div>
            </div>
        </div>


        <div class="action-buttons text-right padding"
            *ngIf="strategyModeControl.value !== StrategyFormBuildMode.TEXT_BUILDER">
            <button mat-flat-button color="accent" type="button" (click)="saveData()"
                class="ut-pro-button gradient submit-button margin-8-hr height-36" *ngIf="!isEditing">
                <span class="font-inter-semibold">
                    Save and Proceed
                </span>
            </button>
            <button mat-flat-button color="accent" class="ut-pro-button gradient submit-button margin-8-hr height-36"
                (click)="updateStrategy(false)" *ngIf="isEditing && !isEditBacktest"
                [disabled]="!isFinished()">Update</button>
            <button mat-flat-button color="accent" class="margin-8-hr" (click)="updateStrategy(true)"
                [disabled]="!isFinished()" *ngIf="isEditBacktest">
                Done
            </button>

            <!-- <button mat-flat-button color="accent" class="margin-8-hr">Forward Test</button>
      <button mat-flat-button color="accent" class="margin-8-hr">Deploy</button>
      <button mat-flat-button color="accent" class="margin-8-hr" (click)="runBackTest()">Backtest</button> -->
        </div>

    </mat-card>
</div>
